/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Legal_Name_BusinessInputs */

const en_label_legal_name_business = /** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Business Name`)
};

const es_label_legal_name_business = /** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre Legal del Negocio`)
};

const fr_label_legal_name_business = /** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom légal de l'entreprise`)
};

const de_label_legal_name_business = /** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offizieller Unternehmensname`)
};

const id_label_legal_name_business = /** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Resmi Bisnis`)
};

/** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */
const ja_label_legal_name_business = en_label_legal_name_business;

/** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */
const zh_label_legal_name_business = en_label_legal_name_business;

/** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */
const ar_label_legal_name_business = en_label_legal_name_business;

/** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */
const it_label_legal_name_business = en_label_legal_name_business;

/** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */
const ru_label_legal_name_business = en_label_legal_name_business;

/** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */
const pt_label_legal_name_business = en_label_legal_name_business;

/** @type {(inputs: Label_Legal_Name_BusinessInputs) => LocalizedString} */
const ko_label_legal_name_business = en_label_legal_name_business;

/**
* | output |
* | --- |
* | "Legal Business Name" |
*
* @param {Label_Legal_Name_BusinessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_legal_name_business = /** @type {((inputs?: Label_Legal_Name_BusinessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Legal_Name_BusinessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_legal_name_business(inputs)
	if (locale === "es") return es_label_legal_name_business(inputs)
	if (locale === "fr") return fr_label_legal_name_business(inputs)
	if (locale === "de") return de_label_legal_name_business(inputs)
	if (locale === "ja") return ja_label_legal_name_business(inputs)
	if (locale === "zh") return zh_label_legal_name_business(inputs)
	if (locale === "ar") return ar_label_legal_name_business(inputs)
	if (locale === "id") return id_label_legal_name_business(inputs)
	if (locale === "it") return it_label_legal_name_business(inputs)
	if (locale === "ru") return ru_label_legal_name_business(inputs)
	if (locale === "pt") return pt_label_legal_name_business(inputs)
	return ko_label_legal_name_business(inputs)
});